<template>
  <li class="shop_item">
    <router-link :to="'/supermarket/shop_home?shop_id='+item.id" class="item_link" target="_blank">
      <img class="shop_logo" v-lazy="item.coverPath" :key="item.coverPath" />
      <h3>{{item.shop_name}}</h3>
      <div class="lab">
        主营业务：
        <span>{{item.business_range}}</span>
      </div>
      <hotLabels  v-if="item.is_coupon" style="position: absolute;left: 20px;bottom: 20px"></hotLabels>
    </router-link>
  </li>
</template>

<script>
import hotLabels from "@/components/mall/hot_labels.vue";
export default {
  components: { hotLabels },
  props: {
    item: {
      type: Object
    },
    configs: {
      type: Object,
      default() {
        return {
          progress: false
        };
      }
    }
  },
  methods: {
    detail(name, obj) {
      // this.$store.dispatch('updateShopInfo',obj)
      this.$router.push({
        path: '/supermarket/shop_home',
        query: {
          id: obj.id
        }
      });
    },
    // 秒转换为时分秒
    test(s) {
      var hour = Math.floor(s / 3600);
      hour = hour < 10 ? "0" + hour : hour;
      var minute = Math.floor((s - hour * 3600) / 60);
      minute = minute < 10 ? "0" + minute : minute;
      var second = Math.floor(s - hour * 3600 - minute * 60);
      second = second < 10 ? "0" + second : second;
      var _html =
        hour > 0 ? `${hour}时${minute}分${second}秒` : `${minute}分${second}秒`;
      return _html;
    }
  }
};
</script>

<style lang="scss" scoped>
.shop_item {
  width: 390px;
  height: 226px;
  margin: 0 15px 15px 0;
  background: #ffffff;
  a {
    display: flex;
    flex-direction: column;
    padding: 20px;
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    .shop_logo {
      width: 90px;
      height: 90px;
      border-radius: 4px;
      object-fit: cover;
      object-position: center;
    }
    h3 {
      font-size: 16px;
      font-weight: 500;
      color: #4c5062;
      margin-top: 19px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .lab {
      font-size: 14px;
      color: #a4a8ba;
      margin-top: 14px;
      display: flex;

      span {
        color: #dedede;
        width: 278px;
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>